module.exports = __webpack_public_path__ + "img/Blendor Sefaj.fb5d2976.jpg";